// extracted by mini-css-extract-plugin
export default {"TaxesAndFees__priceRow":"TaxesAndFees_TaxesAndFees__priceRow__AM-J+","TaxesAndFees__dottedHr":"TaxesAndFees_TaxesAndFees__dottedHr__fMh7V"};